<template>
  <div>
    <div
      class="HJXLink_container"
      v-if="cityDetail.haveFootLink && cityDetail.footLinkList"
    >
      <div class="HJXLink_title">友情链接:</div>
      <div class="link-list">
        <div v-for="(link, index) in linkList" :key="index" class="link">
          <a :href="link.url" class="linkUrl" target="_blank">
            {{ link.label }}
          </a>
        </div>
      </div>
    </div>
    <div class="footer" v-if="cityDetail.footList">
      <span v-for="(item, index) in cityDetail.footList" :key="index"
        >{{ item.title }}:{{ item.company }}</span
      >
    </div>
    <div class="footer" v-else>
      <span>主管部门:{{ cityDetail.cityName }}农业农村局</span>
    </div>
  </div>
</template>

<script>
import { cityDetail } from '../util/mainOption'

export default {
  data () {
    return {
      linkList: [
        {
          label: "农业农村部",
          url: "https://www.moa.gov.cn/",
        },
        {
          label: "农业农村厅",
          url: "https://nynct.henan.gov.cn/",
        },
        {
          label: "自然资源部",
          url: "https://www.mnr.gov.cn/",
        },
        {
          label: "公共资源交易中心",
          url: "https://www.ggzy.gov.cn/",
        },
        {
          label: "获嘉县人民政府",
          url: "http://www.huojia.gov.cn/",
        },
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.HJXLink_container {
  display: flex;
  align-items: center;
  width: 1864px;
  margin: 0 auto;
  margin-bottom: 20px;
  position: relative;
  justify-content: center;
  .HJXLink_title {
    font-size: 22px;
    padding: 0 20px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
  }
  .link-list {
    display: flex;
    align-items: center;
    justify-items: center;
    .link {
      //width: 250px;
      padding: 0 60px;
      text-align: center;
      position: relative;
      .linkUrl {
        font-size: 22px;
      }
      &::before {
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 1px;
        background-color: #ccc;
      }
      &:last-child::before {
        height: 100%;
        width: 0px;
      }
    }
  }
}
.footer {
  height: 44px;
  width: 100%;
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer > span {
  font-family: Source Han Sans;
  text-align: center;
  opacity: 1;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #363636;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0 52px;
}
.footer > span:last-child {
  border-right: none;
}
</style>
